module.exports = __webpack_public_path__ + "img/04.23862933.svg";